exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottomFix[data-v-93ad6ede]{height:62px}", ""]);

// exports
